import { HttpGet } from "../utils/request";

export function totalGEXtData(ticker) {
     return HttpGet(`/api/v2/totalgex_sql?ticker=${ticker}`)
}

export function detailedGEXtData(ticker, date) {
     return HttpGet(`/api/v2/detailedgex?ticker=${ticker}&date=${date}`)
}
